import React from 'react';
import { TruckIcon } from 'lucide-react';
import MerchCategoryPage, { MerchProduct } from '../../components/Merch/MerchCategoryPage';
const homeProducts: MerchProduct[] = [{
  id: 'h1',
  name: 'Old Library Soy Candle',
  vendorName: 'LitCandleCo',
  vendorSlug: 'lit-candle-co',
  vendorImage: 'https://images.unsplash.com/photo-1544301679-a814c10cd399?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1602874801007-aa87ff42a45e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 22.0,
  rating: 4.9,
  reviewCount: 340,
  subcategory: 'Candles',
  tags: ['scented', 'soy wax', 'cozy'],
  description: 'Hand-poured soy candle with notes of leather, paper, and vanilla.',
  shipping: 'US Only',
  location: 'Chicago, IL'
}, {
  id: 'h2',
  name: 'Literary Quote Mug',
  vendorName: 'LondonBookLovers',
  vendorSlug: 'london-book-lovers',
  vendorImage: 'https://images.unsplash.com/photo-1571331627305-b3c24197a15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 16.0,
  rating: 4.7,
  reviewCount: 185,
  subcategory: 'Mugs',
  tags: ['ceramic', 'tea', 'coffee'],
  description: 'Ceramic mug featuring a classic quote about tea and books.',
  shipping: 'Worldwide',
  location: 'London, UK'
}, {
  id: 'h3',
  name: 'Cozy Reading Blanket',
  vendorName: 'LiteraryThreads',
  vendorSlug: 'literary-threads',
  vendorImage: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1580301762395-9c64265e9c5d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 45.0,
  rating: 4.8,
  reviewCount: 92,
  subcategory: 'Blankets',
  tags: ['fleece', 'soft', 'winter'],
  description: 'Ultra-soft fleece throw blanket with a bookshelf pattern.',
  shipping: 'Worldwide',
  location: 'Seattle, WA'
}, {
  id: 'h4',
  name: 'Dragon Egg Bookends',
  vendorName: 'FantasyRealmCrate',
  vendorSlug: 'fantasy-realm-crate',
  vendorImage: 'https://images.unsplash.com/photo-1578950435899-d1c1bf932b1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1615266895738-11f1371cd7e5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 65.0,
  rating: 4.9,
  reviewCount: 45,
  subcategory: 'Bookends',
  tags: ['decor', 'fantasy', 'heavy'],
  description: 'Heavy resin bookends shaped like cracked dragon eggs.',
  shipping: 'Worldwide',
  location: 'Denver, CO'
}, {
  id: 'h5',
  name: 'Book Stack Coasters',
  vendorName: 'WhimsyReads',
  vendorSlug: 'whimsy-reads',
  vendorImage: 'https://images.unsplash.com/photo-1586892477838-2b96e85e0f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1616593871235-c296d634d4c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 18.0,
  rating: 4.6,
  reviewCount: 78,
  subcategory: 'Coasters',
  tags: ['wood', 'handmade', 'set'],
  description: 'Set of 4 wooden coasters engraved with book stack designs.',
  shipping: 'Worldwide',
  location: 'Portland, OR'
}, {
  id: 'h6',
  name: 'Reading Nook Pillow',
  vendorName: 'PageTurnerTotes',
  vendorSlug: 'page-turner-totes',
  vendorImage: 'https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 28.0,
  rating: 4.7,
  reviewCount: 112,
  subcategory: 'Pillows',
  tags: ['decor', 'comfort', 'cotton'],
  description: 'Square throw pillow with "Go Away, I\'m Reading" typography.',
  shipping: 'Worldwide',
  location: 'Austin, TX'
}, {
  id: 'h7',
  name: 'Haunted Library Candle',
  vendorName: 'DarkAndDisturbed',
  vendorSlug: 'dark-and-disturbed',
  vendorImage: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1603006905003-be475563bc59?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 24.0,
  rating: 4.8,
  reviewCount: 67,
  subcategory: 'Candles',
  tags: ['scented', 'gothic', 'mystery'],
  description: 'Atmospheric candle with scents of dust, rain, and old parchment.',
  shipping: 'US & Canada',
  location: 'Salem, MA'
}, {
  id: 'h8',
  name: 'Maple Scented Candle',
  vendorName: 'TorontoBookishGoods',
  vendorSlug: 'toronto-bookish-goods',
  vendorImage: 'https://images.unsplash.com/photo-1544816155-12df9643f363?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1570823635306-250abb06d4b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 20.0,
  rating: 4.9,
  reviewCount: 55,
  subcategory: 'Candles',
  tags: ['scented', 'sweet', 'autumn'],
  description: 'Sweet maple syrup scented candle, perfect for fall reading.',
  shipping: 'North America',
  location: 'Toronto, Canada'
}];
const HomeLiving = () => {
  return <MerchCategoryPage title="Home & Living" description="Create your dream reading sanctuary. Shop candles, mugs, blankets, and decor to make every reading session magical." icon={<TruckIcon className="h-5 w-5" data-id="element-10478" data-mp="8o0rm9qa4eth" />} products={homeProducts} filterOptions={{
    subcategories: ['Candles', 'Mugs', 'Blankets', 'Pillows', 'Coasters', 'Bookends'],
    priceRanges: [{
      label: 'Under $20',
      min: 0,
      max: 20
    }, {
      label: '$20 - $40',
      min: 20,
      max: 40
    }, {
      label: '$40+',
      min: 40,
      max: null
    }],
    vendors: Array.from(new Set(homeProducts.map(p => p.vendorName))).sort()
  }} data-id="element-10477" data-mp="hludsrubxs2x" />;
};
export default HomeLiving;